module.exports = __webpack_public_path__ + "static/img/h-01.3b5c1d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h-01.jpg
// module id = 88RU
// module chunks = 1